import axios from "@/axios";
export const homeApi = {
  getHomeModule(id) {
    return axios({
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      url: axios.dataUrl.teplUrl.searchTemplateModule,
      data: JSON.stringify(id)
    }).then(res => {
      return res.data;
    });
  },
  appHomePage(id) {
    return axios({
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      url: axios.dataUrl.teplUrl.appHomePage,
      data: JSON.stringify(id)
    }).then(res => {
      return res.data;
    });
  },
  getHomeModuleInfo(ids) {
    return axios({
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      url: axios.dataUrl.teplUrl.searchModuleInfo,
      data: ids
    }).then(res => {
      return res.data;
    });
  },
  addModuleInfo(data) {
    return axios({
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      url: axios.dataUrl.teplUrl.addModuleInfo,
      data: data
    }).then(res => {
      return res.data;
    });
  },
  editModuleInfo(data) {
    return axios({
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      url: axios.dataUrl.teplUrl.modifyModuleInfo,
      data: data
    }).then(res => {
      return res.data;
    });
  },
  getGoodsList(data) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.goodsList,
      data: data
    }).then(res => {
      return res.data;
    });
  },
  timeElevator(title){
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.timeElevator,
      data: {title,page:{
        pageNo:0,
        pageSize:0
      }}
    })
  },
  checkGoods(ids) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.goodsDetail,
      data: ids
    }).then(res => {
      return res.data;
    });
  },
  addModuleGoods(data) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.addModuleGoods,
      data: data
    }).then(res => {
      return res.data;
    });
  },
  searchModuleGoods(id) {
    return axios({
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      url: axios.dataUrl.teplUrl.searchModuleGoods,
      data: JSON.stringify(id)
    }).then(res => {
      return res.data;
    });
  },
  modifyModuleGoods(data) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.modifyModuleGoods,
      data: data
    }).then(res => {
      return res.data;
    });
  },
  addTemplateTitle(data) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.addTemplateTitle,
      data: data
    }).then(res => {
      return res.data;
    });
  },
  modifyTemplateTitle(data) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.modifyTemplateTitle,
      data: data
    }).then(res => {
      return res.data;
    });
  },
  searchTemplateTitle(id) {
    return axios({
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      url: axios.dataUrl.teplUrl.searchTemplateTitle,
      data: JSON.stringify(id)
    }).then(res => {
      return res.data;
    });
  },
  searchTitleGoods(id) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.searchTitleGoods,
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: JSON.stringify(id)
    }).then(res => {
      return res.data;
    });
  },
  modifyTitleGoods(data) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.modifyTitleGoods,
      data: data
    }).then(res => {
      return res.data;
    });
  },
  removeTitleGoods(id) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.removeTitleGoods,
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: JSON.stringify(id)
    }).then(res => {
      return res.data;
    });
  },
  removeModuleGoods(id) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.removeModuleGoods,
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: JSON.stringify(id)
    }).then(res => {
      return res.data;
    });
  },
  clearCache() {
    return axios({
      method: "post",
      url: "http://10.70.13.86/decorate/appHomePage/refreshCache",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: JSON.stringify("956479901225881602")
    }).then(res => {
      return res.data;
    });
  },
  removeTemplateTitle(id) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.removeTemplateTitle,
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: JSON.stringify(id)
    }).then(res => {
      return res.data;
    });
  },
  addSecondTitle(data) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.addSecondTitle,
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: data
    }).then(res => {
      return res.data;
    });
  },
  updateHomeComponent(data) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.updateHomeComponent,
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      data: data
    }).then(res => {
      return res.data;
    });
  },
  searchHomeComponent(id) {
    return axios({
      method: "post",
      url: axios.dataUrl.teplUrl.searchHomeComponent + id + '/1',
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
    }).then(res => {
      return res.data;
    });
  }
};
